import type { RootState } from 'store/root/reducers';

const getCurrentState = (state: RootState) => state['apt'];

const aptSelectors = {
  appointments: (state: RootState) => getCurrentState(state).appointments,
  blockHours: (state: RootState) => getCurrentState(state).blockHours,
  params: (state: RootState) => getCurrentState(state).params,
  date: (state: RootState) => getCurrentState(state).date,
  loading: (state: RootState) => getCurrentState(state).loading,
  loadedParams: (state: RootState) => getCurrentState(state).loadedParams,
};

export default aptSelectors;
